import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { FiTrendingUp } from 'react-icons/fi';

export function DetailFooter({ market, onTradeClick }) {
  const { t } = useTranslation();
  const [countdown, setCountdown] = useState({ hours: 0, minutes: 0 });

  // Calculate countdown to game time
  useEffect(() => {
    if (!market?.gameTime) return;

    const updateCountdown = () => {
      const now = new Date();
      const gameTime = new Date(market.gameTime);
      const diff = gameTime - now;

      if (diff <= 0) {
        setCountdown({ hours: 0, minutes: 0 });
        return;
      }

      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      setCountdown({ hours, minutes });
    };

    updateCountdown();
    const timer = setInterval(updateCountdown, 60000); // Update every minute

    return () => clearInterval(timer);
  }, [market?.gameTime]);

  return (
    <footer className="fixed bottom-0 left-0 right-0 bg-surface/90 backdrop-blur border-t border-glass-border py-2 px-4 z-50">
      <div className="max-w-7xl mx-auto flex items-center justify-between text-sm">
        {/* Connection Status */}
        <div className="flex items-center gap-2">
          <span className="w-2 h-2 rounded-full bg-positive animate-pulse"></span>
          <span className="text-positive">{t('footer.connected')}</span>
        </div>

        {/* Match Info */}
        <div className="flex items-center gap-2 text-slate-400">
          <span>|</span>
          <span>🏀</span>
          <span className="text-white">{market?.teamA}</span>
          <span>vs</span>
          <span className="text-white">{market?.teamB}</span>
        </div>

        {/* Countdown */}
        {market?.status === 'upcoming' && (
          <div className="flex items-center gap-2 text-slate-400">
            <span>|</span>
            <span>⏳</span>
            <span>{t('footer.countdown')}</span>
            <span className="text-white font-mono">
              {countdown.hours}h {countdown.minutes}m
            </span>
          </div>
        )}

        {/* Navigation Links */}
        <div className="flex items-center gap-3">
          <button
            onClick={onTradeClick}
            className="flex items-center gap-2 px-4 py-1.5 rounded-lg bg-gradient-to-r from-accent-strong to-accent text-white text-sm font-medium shadow-lg shadow-accent/20 hover:shadow-accent/30 transition-all active:scale-95"
          >
            <FiTrendingUp size={16} />
            {t('trading.trade')}
          </button>
          <span className="text-slate-600">|</span>
          <Link to="/" className="text-slate-400 hover:text-white transition-colors">
            ← {t('footer.home')}
          </Link>
          <span className="text-slate-600">|</span>
          <a
            href="https://t.me/polysportschannel"
            target="_blank"
            rel="noopener noreferrer"
            className="text-slate-400 hover:text-accent transition-colors"
            title={t('footer.joinTelegram')}
          >
            {t('footer.telegram')}
          </a>
          <a
            href="https://x.com/polysports_ai"
            target="_blank"
            rel="noopener noreferrer"
            className="text-slate-400 hover:text-accent transition-colors"
            title={t('footer.followX')}
          >
            {t('footer.twitter')}
          </a>
        </div>
      </div>
    </footer>
  );
}
